import React from 'react';
import { FileText } from '@phosphor-icons/react';

function TaskDescriptionCard({ task }) {
  return (
    <section className="rounded-3xl border border-line bg-surface/80 p-6 shadow-lg shadow-black/10">
      <div className="mb-4 flex items-center gap-3">
        <div className="rounded-xl bg-surface-2 p-2 text-content-muted">
          <FileText size={20} />
        </div>
        <h2 className="text-lg font-semibold text-content">Descripción</h2>
      </div>

      <p className="whitespace-pre-wrap text-base text-content">
        {task?.description?.trim() || 'La tarea no tiene una descripción cargada.'}
      </p>
    </section>
  );
}

export default TaskDescriptionCard;
